import script from "./TableHeaderControls.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableHeaderControls.vue?vue&type=script&lang=ts&setup=true"

import "./TableHeaderControls.vue?vue&type=style&index=0&id=d39e454a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d39e454a"]])

export default __exports__